import { Box, Typography } from '@mui/material'
import React from 'react'
import Grid from '@mui/material/Grid2';
import { ReactFitty } from 'react-fitty';
import img1 from '../../assets/img/projectsPage/img1.png'
import img2 from '../../assets/img/projectsPage/img2.png'
import img3 from '../../assets/img/projectsPage/img3.png'

const PortfolioProject = () => {
  return (
    <Box height={"100dvh"} sx={{ backgroundColor: '#e5e8d9' }}>
      <Box sx={{
        padding: '100px',
        height: '20%',
        borderBottom: '4px solid #fd4002',
        '@media screen and (max-width: 600px)': {
          height: '10%',
          padding: '10px',
        }
      }}>
        <Typography
          sx={{
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
            lineHeight: 0.7,
            marginTop: "-40px",
            color: '#fd4002',
            '@media screen and (max-width: 600px)': {
              marginTop: "35px",
            }
          }}
          component={ReactFitty}
        >
          PORTFOLIO
        </Typography>
        <Typography
          sx={{
            fontFamily: "Great Vibes",
            textAlign: 'center',
            position: 'relative',
            zIndex: 3,
            width: '100%',
            fontSize: '9rem',
            padding: '0 30px',
            marginTop: '-250px',
            color: '#191b1e',
            '@media screen and (max-width: 600px)': {
              fontSize: '4rem',
              marginTop: '-70px',
            },
            '@media screen and (min-width: 601px) and (max-width: 900px)': {
              fontSize: '5rem',
              marginTop: '-100px',
            },
            '@media screen and (min-width: 901px) and (max-width: 1200px)': {
              fontSize: '6rem',
              marginTop: '-120px',
            }
          }}>
          Projects
        </Typography>
      </Box>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: '#191b1e',
          zIndex: 2,
          position: 'relative',
          height: '80%',
          overflow: 'hidden',
          '@media screen and (max-width: 1200px)': {
            padding: '10px',
            marginTop: '0px',
            height: '90%',
            '& div': {
              height: '30%'
            },
            '& img': {
              width: '100%'
            }
          }
        }}
      >
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img1} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img2} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img3} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default PortfolioProject